/**
 * How somebody who lives here says a thing (M4-08, generalised in M5-01).
 *
 * Two functions, and they are here rather than in `village.ts` for one reason:
 * the Meddyg's services, the Smith's stall and the conversation that dispatches
 * to both all need them, and a helper that lived in the dispatcher would make
 * every service import the thing that imports it. A leaf costs nothing and the
 * cycle would cost an afternoon.
 *
 * Speech is `earshot`, not `actor`. A conversation in a doorway is a
 * conversation the people in the doorway can hear, and the alternative — private
 * lines only the asker sees — would make the village read as a set of vending
 * machines standing near each other rather than as a place with people in it.
 */
/** How far away somebody will answer you from. Conversation range, not shouting. */
export const TALK_RANGE = 2;
/**
 * One line from a pool, chosen by the tick.
 *
 * By the tick rather than by the RNG, deliberately: a replay hears the same
 * words in the same order, and choosing dialogue out of a random stream would
 * make every villager's small talk a thing that shifts the dice for everybody
 * else in the valley.
 *
 * An empty or absent pool yields an ellipsis rather than throwing. A villager
 * with nothing written for a topic should stand there and say nothing much,
 * which is a content gap somebody notices in a playtest — not a tick that dies.
 */
export function line(pool, tick) {
    if (!pool || pool.length === 0)
        return '…';
    return pool[tick % pool.length];
}
/** One thing they say, to one person, in front of whoever is standing there. */
export function say(ctx, speaker, to, text, ref) {
    ctx.emit({
        type: 'said',
        actors: [speaker.id, to.id],
        refs: ['villager', ref],
        text: `${speaker.name}: "${text}"`,
        audience: 'earshot',
        range: TALK_RANGE + 2,
        at: { x: speaker.x, y: speaker.y },
    });
}
//# sourceMappingURL=voice.js.map